import React, { Component } from 'react';
import Sticky from 'Components/Sticky';
import Heading from 'Components/Heading';
import Checkbox from 'Components/Checkbox/index';
import { CARGO_SHIPMENT } from 'Constants/commonConstants';
import { ReactComponent as SearchIcon } from 'Components/SearchDropdown/icons/search.svg';
import { ReactComponent as Details } from 'Icons/details.svg';
import { ReactComponent as FlightIcon } from 'Icons/plane.svg';
import Select from 'react-select';
import Tabs from 'Components/Tabs';
import { connect } from 'react-redux';
import ActionLoader from 'Components/ActionLoader';
import { GET_CARGO_SHIPMENT_TRACKING_DATA, SAVE_CARGO_SHIPMENT_TRACKING_DATA } from 'Constants/actionConstants';
import { DateRangePicker } from 'react-dates';
import Upload from 'Components/Upload';
import Moment from 'moment';
import { SeaDetails } from './SeaDetails';
import { AirDetails } from './AirDetails';

const trackingOptions = [{name: 'Container No', id: 1}, {name: 'BL No.', id: 2}];

class CargoTracking extends Component {
    constructor() {
        super();
        this.state = {
            cargoShipment: 1,
            search: [],
            selectedTab: 1,
            filters: {},
            trackingType: 1
        }
    }

    selectCargoShipment = (value) => {
        if(value !== this.state.cargoShipment) {
            this.setState({
                cargoShipment: value,
                search: []
            });
            this.props.dispatch({
                type: SAVE_CARGO_SHIPMENT_TRACKING_DATA,
                data: []
            })
        }
    }

    onHandleChange = (id, evt) => {
        if(evt.target.value){
            let { search } = this.state;
            let data = evt.target.value.split(',');
            for(var i in data) {
                if(data[i].trim()){
                    search.push(data[i].trim());
                }
            }
            this.setState({ search });
        }
    }

    onChange = (id, options) => {
        let search = [];
        for(var i in options) {
            search.push(options[i].label);
        }
       this.setState({ search });
    }

    getTrackingDetails = () => {
        const { dispatch } = this.props;
        const { cargoShipment, search, trackingType } = this.state;
        dispatch({
            type: GET_CARGO_SHIPMENT_TRACKING_DATA,
            cargoType: cargoShipment,
            trackingType,
            data: {
                [cargoShipment === 1 ? (trackingType === 1 ? 'numbers' : 'bl_number') : 'track_number']: search
            }
        })
    }

    uploadTrackingDetails = () => {

    }

    downloadTemplate = () => {

    }

    selectTrackingOption = (id) => {
       if(id !== this.state.trackingType) {
           this.setState({
               trackingType: id,
               search: []
           });
           this.props.dispatch({
               type: SAVE_CARGO_SHIPMENT_TRACKING_DATA,
               data: []
           })
       }
    }

    getCargoTable = (trackingData) => {
        return (
        <div className="courier-table pv-20 ph-10 cargo-tracking-table">
            <table cellPadding="0" cellSpacing="0" width="100%">
                <thead>
                    <tr>
                        <th>Sl No.</th>
                        {this.state.trackingType === 2 && <th>BL No.</th>}
                        <th>{'Container No'}</th>
                        {/* <th>{'Sea Line'}</th> */}
                        <th width="300">{'Origin Port'}</th>
                        <th width="150">{'ETD(Origin Port)'}</th>
                        <th width="150">{'ATD(Actual Time of Departure)'}</th>
                        <th width="300">{'Destination Port'}</th>
                        <th width="150">{'ETA (Destination Port)'}</th>
                        <th width="150">{'ATA(Actual Time of Arrival)'}</th>
                        <th>{'Current Location'}</th>
                        <th>{'Status'}</th>
                        <th>{'Action'}</th>
                    </tr>
                </thead>
                <tbody>
                {this.state.trackingType === 2 ? <>
                    {(trackingData || []).map((blData, index) => (
                    <>{(blData.containers || []).map((data, dataIndex) => {
                        const currentEvent = [];
                        (data.events || []).forEach(cEvent => {
                            if((Moment(cEvent.date).valueOf()) <= (Moment().valueOf())) {
                                currentEvent.push(cEvent);
                            }
                        });
                        const isError = data.hasOwnProperty('message');
                        return(<tr>
                                {dataIndex === 0 && <>
                                <td style={{'borderBottom': '1px solid grey'}} rowSpan={blData.containers.length}>{index + 1}</td>
                                <td style={{'borderBottom': '1px solid grey'}} rowSpan={blData.containers.length}>{blData.bl_number}</td>
                                </>}
                            
                                    <td style={{'borderBottom': '1px solid grey'}}>{data.number}</td>
                                    {isError ?
                                    <td style={{'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}} colSpan="10">
                                        <span className="error-color fs-16 fBold">{data.message}</span>
                                    </td> :
                                    <>
                                        {/* <td style={{'borderBottom': '1px solid grey'}}>{'-'}</td> */}
                                        <td style={{'borderBottom': '1px solid grey'}}>{`${(data.from || {}).from}, ${(data.from || {}).state}, ${(data.from || {}).country}`}</td>
                                        <td style={{'borderBottom': '1px solid grey'}}>{(data.from || {}).date && Moment((data.from || {}).date).format('DD MMM YYYY HH:mm:ss')}</td>
                                        <td style={{'borderBottom': '1px solid grey'}}>{(data.from || {}).actual && Moment((data.from || {}).date).format('DD MMM YYYY HH:mm:ss') || '-'}</td>
                                        <td style={{'borderBottom': '1px solid grey'}}>{`${(data.to || {}).from}, ${(data.to || {}).state}, ${(data.to || {}).country}`}</td>
                                        <td style={{'borderBottom': '1px solid grey'}}>{(data.to || {}).date && Moment((data.to || {}).date).format('DD MMM YYYY HH:mm:ss')}</td>
                                        <td style={{'borderBottom': '1px solid grey'}}>{(data.to || {}).actual && Moment((data.to || {}).date).format('DD MMM YYYY HH:mm:ss') || '-'}</td>
                                        <td style={{'borderBottom': '1px solid grey'}}>{currentEvent[currentEvent.length -1].name}</td>
                                        <td style={{'borderBottom': '1px solid grey'}}>{currentEvent[currentEvent.length -1].description}</td>
                                        <td style={{'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>
                                            <Details className="wt-20 ht-20 mt-8 serach-icon curP" onClick={() => this.setState({ isOpen: true, seaData: data })}/>
                                        </td>
                                    </>}
                            
                        </tr>)
                        })}
                    </>
                    ))}
                </> :
                <>
                {(trackingData || []).map((data, index) => {
                    const currentEvent = [];
                    (data.events || []).forEach(cEvent => {
                        if((Moment(cEvent.date).valueOf()) <= (Moment().valueOf())) {
                            currentEvent.push(cEvent);
                        }
                    });
                    const isError = data.hasOwnProperty('message');
                    return(<tr>
                        <td style={{'borderBottom': '1px solid grey'}}>{index + 1}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{data.container_number}</td>
                        {isError ?
                        <td style={{'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}} colSpan="10">
                            <span className="error-color fs-16 fBold">{data.message}</span>
                        </td> :
                        <>
                        {/* <td style={{'borderBottom': '1px solid grey'}}>{'-'}</td> */}
                        <td style={{'borderBottom': '1px solid grey'}}>{`${(data.from || {}).from}, ${(data.from || {}).state}, ${(data.from || {}).country}`}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{(data.from || {}).date && Moment((data.from || {}).date).format('DD MMM YYYY HH:mm:ss')}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{(data.from || {}).actual && Moment((data.from || {}).date).format('DD MMM YYYY HH:mm:ss') || '-'}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{`${(data.to || {}).from}, ${(data.to || {}).state}, ${(data.to || {}).country}`}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{(data.to || {}).date && Moment((data.to || {}).date).format('DD MMM YYYY HH:mm:ss')}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{(data.to || {}).actual && Moment((data.to || {}).date).format('DD MMM YYYY HH:mm:ss') || '-'}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{currentEvent[currentEvent.length -1].name}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{currentEvent[currentEvent.length -1].description}</td>
                        <td style={{'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>
                            <Details className="wt-20 ht-20 mt-8 serach-icon curP" onClick={() => this.setState({ isOpen: true, seaData: data })}/>
                        </td>
                        </>}
                    </tr>)
                })}
                </>}
                </tbody>
            </table>
        </div>
        )
    }

    getAirCargoTable = (trackingData) =>{
        return (
        <div className="courier-table pv-20 ph-10 cargo-tracking-table">
            <table cellPadding="0" cellSpacing="0" width="100%">
                <thead>
                    <tr>
                        <th>Sl No.</th>
                        <th width="150">{'Tracking No'}</th>
                        <th>{'Airline'}</th>
                        <th>{'Origin'}</th>
                        <th width="200">{'ETD(Origin)'}</th>
                        <th width="200">{'ATD(Actual Time of Departure)'}</th>
                        <th>{'Dest.'}</th>
                        <th width="200">{'ETA (Destination)'}</th>
                        <th width="200">{'ATA(Actual Time of Arrival)'}</th>
                        {/* <th>{'Flight Way Station'}</th> */}
                        <th>{'Weight'}</th>
                        <th width="50">{'No. of Units'}</th>
                        <th width="150">{'Status'}</th>
                        <th>{'Action'}</th>
                    </tr>
                </thead>
                <tbody>
                {(trackingData || []).map((data, index) => {
                    const orginFligt = (data.flight_info || {})[Object.keys(data.flight_info || {})[0]] || {};
                    const destinationFlight = ((data.flight_info || {})[Object.keys(data.flight_info || {})[Object.keys(data.flight_info || {}).length - 1]]) || {};
                    const isError = data.hasOwnProperty('message');
                    return(<tr>
                        <td style={{'borderBottom': '1px solid grey'}}>{index + 1}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{data.track_number}</td>
                        {isError ?
                        <td style={{'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}} colSpan="11">
                            <span className="error-color fs-16 fBold">{data.message}</span>
                        </td> :
                        <>
                        <td style={{'borderBottom': '1px solid grey'}}>{data.name}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{data.origin}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{orginFligt.plan_depart_time && Moment(orginFligt.plan_depart_time).format('DD MMM YYYY HH:mm:ss')}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{orginFligt.depart_time && Moment(orginFligt.depart_time).format('DD MMM YYYY HH:mm:ss')}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{data.destination}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{destinationFlight.plan_arrival_time && Moment(orginFligt.plan_arrival_time).format('DD MMM YYYY HH:mm:ss')}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{destinationFlight.arrival_time && Moment(orginFligt.arrival_time).format('DD MMM YYYY HH:mm:ss')}</td>
                        {/* <td style={{'borderBottom': '1px solid grey'}}>{(data.flight_way_station || []).join(' -> ')}</td> */}
                        <td style={{'borderBottom': '1px solid grey'}}>{data.weight}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{data.piece}</td>
                        <td style={{'borderBottom': '1px solid grey'}}>{data.last_event}</td>
                        <td style={{'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}}>
                            <Details className="wt-20 ht-20 mt-8 serach-icon curP mr-5" onClick={() => this.setState({ isAirDeatilsOpen: true, airData: data, flightInfo: false })}/>
                            <FlightIcon className="wt-20 ht-20 mt-8 serach-icon curP" onClick={() => this.setState({ isAirDeatilsOpen: true, airData: data, flightInfo: true })}/>
                        </td>
                        </>}
                    </tr>)
                })}
                </tbody>
            </table>
        </div>
        )
    }

    getFilters = () => {
        const { filters } = this.state;
        return (
            <>
                <div className="mr-10">
                    <DateRangePicker
                        startDate={filters.fromDate ? Moment(filters.fromDate || null) : null}
                        startDateId="startDate"
                        endDate={filters.toDate ? Moment(filters.toDate) : null}
                        endDateId="endDate"
                        onDatesChange={({ startDate, endDate }) => {
                            const { filters } = this.state;
                            filters.fromDate = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0)
                            filters.toDate = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                            this.setState({
                                filters
                            })
                        }}
                        focusedInput={this.state.focusedInput}
                        onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                        displayFormat={'DD MMM YYYY'}
                        noBorder={true}
                        minimumNights={0}
                        isOutsideRange={() => false}
                    />
                </div>
                <Select className="wt-300 mr-10" placeholder={'Select Carrier / AirLines'}/>
                <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10" onClick={this.downloadTemplate}>Download</button>
                <Upload onChange={this.uploadTrackingDetails}>
                    <button className={"ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-10"}>Upload</button>
                </Upload>
            </>
        )
    }

    render() {
        const { cargoShipment, search, selectedTab, isOpen, seaData, isAirDeatilsOpen, airData, flightInfo, trackingType } = this.state;
        const { trackingData, loader } = this.props;
        return (
            <Sticky>
                {loader && <ActionLoader fixed={true} />}
                <div className="bg-white cargo-tracking">
                    <Heading text="EXIM Cargo Tracking" className="tCenter mt-10"/>
                    <div className="mt-10 ph-10">
                        <Tabs key={1} selectTab={(id) => this.setState({ selectedTab: 1 })} activeTabId={selectedTab} tabs={[{value: 'Adhoc', id: 1}, {value: 'Bulk Track', id: 2}]} isBold={true}/>
                    </div>
                    <div className="flex flex-center mt-10 fBold header-dark-color fs-16 pv-10">
                        {(CARGO_SHIPMENT || []).map(cargo => <Checkbox label={cargo.name} checked={cargo.value === cargoShipment} onCheck={() => this.selectCargoShipment(cargo.value)} className="mr-30"/>)}
                    </div>
                    {selectedTab === 1 && <div className="flex flex-center mt-10">
                        {cargoShipment === 1 && (trackingOptions || []).map(tOption => <Checkbox label={tOption.name} checked={tOption.id === trackingType} onCheck={() => this.selectTrackingOption(tOption.id)} className="mr-30"/>)}
                        <Select className={'col-2 select'} isMulti value={(search || []).length > 0 ? search.map(val => { return { label : val, value: val } } ) : null} onBlur={this.onHandleChange.bind(this, 'search')} isClearable={true} onChange={this.onChange.bind(this, 'search')} placeholder={'Please Enter the Tracking Number'}/>
                        <button className="ht-38 white-color bg-theme fs-16 fBold pl-30 br-5 pr-30 ml--2" onClick={this.getTrackingDetails}>
                            Track
                        </button>
                        <SearchIcon className="wt-20 ht-20 mr-10 mt-8 serach-icon" style={{'marginLeft':"-93px"}} />
                    </div>}
                    {selectedTab === 2 && 
                        <div className="flex mt-10 ph-10">
                            {this.getFilters()}
                        </div>
                    }
                </div>
                {trackingData.length > 0 && cargoShipment === 1 && selectedTab === 1 && this.getCargoTable(trackingData)}
                {trackingData.length > 0 && cargoShipment === 2 && selectedTab === 1 && this.getAirCargoTable(trackingData)}
                {
                    isOpen && <SeaDetails 
                        onClose={() => {
                            this.setState({ isOpen: false, seaData: '' });
                        }}
                        seaData={seaData}
                    />
                    
                }
                {
                    isAirDeatilsOpen && <AirDetails 
                        onClose={() => {
                            this.setState({ isAirDeatilsOpen: false, airData: '' });
                        }}
                        data={airData}
                        flightInfo={flightInfo}
                    />
                    
                }
            </Sticky>
        )
    }
}

const mapStateToProps = ({ contracting }) => {
    return {
        loader: contracting.loader,
        trackingData: contracting.trackingData || []
    }
}

export default connect(mapStateToProps)(CargoTracking);